import React from 'react';
import { Grid } from '@material-ui/core';
import { Asset } from 'components/AssetThumbnailView';
import WkblVideoVO from 'commons/vo/WkblVideoVO';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers/type';
import useStorage from 'hooks/useStorage';

function AssetThumbnailView() {
  const { videoList, isLoading } = useSelector((state: RootState) => state.wkblVideo);
  const { getStorage } = useStorage();

  return (
    <Grid container spacing={2}>
      {!isLoading &&
        videoList.map((asset: WkblVideoVO, index) => {
          const storage = getStorage(asset.categoryId);
          asset.symbolicPath = storage.symbolicPath;
          return <Asset key={`${asset.id}_${index}`} asset={asset} />;
        })}
    </Grid>
  );
}

export default AssetThumbnailView;
